// src/slices/productstore/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getProductStoreData, getProductBySlug } from "./thunk";

const initialState = { productStoreData: [], singleProduct: null, loading: false, error: null, pagination: {} };

const productStoreDataSlice = createSlice({
  name: "productStoreData",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      // ================= GET ALL PRODUCTS =================
      .addCase(getProductStoreData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getProductStoreData.fulfilled, (state, action) => {
        state.loading = false;

        state.productStoreData = action.payload?.data?.data;

        state.pagination = action.payload?.data?.responseDetails?.pagination;
      })

      .addCase(getProductStoreData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= GET BY SLUG =================
      .addCase(getProductBySlug.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getProductBySlug.fulfilled, (state, action) => {
        state.loading = false;
        state.singleProduct = action.payload?.data;
      })

      .addCase(getProductBySlug.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default productStoreDataSlice.reducer;
